var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cyma-c-layout"},[_c('cyma-sidebar'),_vm._v(" "),_c('main',{staticClass:"cyma-c-main"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }